import React from 'react'
import Link from 'next/link'
import { teamDetailRoute } from '@/utils/routes'
import classes from './styles.module.scss'

interface ITeamCrestLinkProps {
  team?: { _id?: string, name?: string }
  children: React.ReactNode
}

// The cards this sits in already navigate to the event on click, so the click
// must stop here or the card would follow it to the event straight after.
const stopCardClick = (event: React.MouseEvent) => event.stopPropagation()

/**
 * Wraps a club crest in a link to that club's team page (PRO-1195).
 *
 * Without an `_id` the crest renders bare: `teamDetailRoute()` with no id
 * resolves to the viewer's own favourite team, which would be a wrong link.
 */
export const TeamCrestLink = ({ team, children }: ITeamCrestLinkProps) => {
  if (!team?._id) return <>{children}</>

  return (
    <Link
      href={teamDetailRoute(team._id)}
      // Overrides the crest's alt, so the club is announced once, as a link.
      aria-label={team.name}
      className={classes.link}
      onClick={stopCardClick}
    >
      {children}
    </Link>
  )
}
